import { createAsyncTypes } from 'utils/ActionCreator'

import { DELIVERY, LEVEL_VALUES } from 'containers/AwarenessCenter/constants'

const typeKey = 'AwarenessCenter/WizardSimulationCampaign/ScenariosStep'

export const FETCH_CATEGORIES_ASYNC = createAsyncTypes('FETCH_CATEGORIES', typeKey)
export const AUTO_SELECT_SCENARIOS_ASYNC = createAsyncTypes('AUTO_SELECT_SCENARIOS', typeKey)

export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`
export const CHANGE_SORT_OPTION = `${typeKey}/CHANGE_SORT_OPTION`
export const CHANGE_LEVEL_FILTER = `${typeKey}/CHANGE_LEVEL_FILTER`
export const CHANGE_TYPE_FILTER = `${typeKey}/CHANGE_TYPE_FILTER`
export const CHANGE_CREATED_BY_FILTER = `${typeKey}/CHANGE_CREATED_BY_FILTER`
export const CHANGE_LOCALES = `${typeKey}/CHANGE_LOCALES`
export const PICK_CATEGORY = `${typeKey}/PICK_CATEGORY`
export const SET_IS_VISITED = `${typeKey}/SET_IS_VISITED`

export const DEFAULT_CATEGORY_ID = {
  [DELIVERY.EMAIL]: 0, // 'IT / Support'
}

export const SORT_VALUES = {
  LANGUAGES_MATCH_SORT: 0,
  LAST_UPDATED: 1,
  USED_RECENTLY: 2,
}
export const SORT_LABELS = {
  [SORT_VALUES.LANGUAGES_MATCH_SORT]: 'Languages match',
  [SORT_VALUES.LAST_UPDATED]: 'Last Updated',
  [SORT_VALUES.USED_RECENTLY]: 'Used Recently',
}
export const SORT_OPTIONS = [
  {
    label: SORT_LABELS[SORT_VALUES.LAST_UPDATED],
    value: SORT_VALUES.LAST_UPDATED,
  },
  {
    label: SORT_LABELS[SORT_VALUES.USED_RECENTLY],
    value: SORT_VALUES.USED_RECENTLY,
  },
  {
    label: SORT_LABELS[SORT_VALUES.LANGUAGES_MATCH_SORT],
    value: SORT_VALUES.LANGUAGES_MATCH_SORT,
  },
]

export const LEVEL_LABELS = {
  [LEVEL_VALUES.BEGINNER_LEVEL]: 'Beginner Level',
  [LEVEL_VALUES.MID_LEVEL]: 'Mid Level',
  [LEVEL_VALUES.EXPERT_LEVEL]: 'Expert Level',
  [LEVEL_VALUES.ALL_LEVELS]: 'All Levels',
}

export const LEVEL_WIZARD_OPTIONS = [
  {
    label: LEVEL_LABELS[LEVEL_VALUES.ALL_LEVELS],
    value: LEVEL_VALUES.ALL_LEVELS,
  },
  {
    label: LEVEL_LABELS[LEVEL_VALUES.EXPERT_LEVEL],
    value: LEVEL_VALUES.EXPERT_LEVEL,
  },
  {
    label: LEVEL_LABELS[LEVEL_VALUES.MID_LEVEL],
    value: LEVEL_VALUES.MID_LEVEL,
  },
  {
    label: LEVEL_LABELS[LEVEL_VALUES.BEGINNER_LEVEL],
    value: LEVEL_VALUES.BEGINNER_LEVEL,
  },
]
export const LEVEL_TABLES_LABELS = {
  [LEVEL_VALUES.BEGINNER_LEVEL]: 'Beginner',
  [LEVEL_VALUES.MID_LEVEL]: 'Mid',
  [LEVEL_VALUES.EXPERT_LEVEL]: 'Expert',
}
export const LEVEL_TABLES_OPTIONS = [
  {
    label: LEVEL_LABELS[LEVEL_VALUES.EXPERT_LEVEL],
    value: LEVEL_VALUES.EXPERT_LEVEL,
  },
  {
    label: LEVEL_LABELS[LEVEL_VALUES.MID_LEVEL],
    value: LEVEL_VALUES.MID_LEVEL,
  },
  {
    label: LEVEL_LABELS[LEVEL_VALUES.BEGINNER_LEVEL],
    value: LEVEL_VALUES.BEGINNER_LEVEL,
  },
]
export const LEVEL_KEY_TO_VALUE = {
  beginner: LEVEL_VALUES.BEGINNER_LEVEL,
  mid: LEVEL_VALUES.MID_LEVEL,
  expert: LEVEL_VALUES.EXPERT_LEVEL,
}
export const LEVEL_VALUE_TO_KEY = {
  [LEVEL_VALUES.BEGINNER_LEVEL]: 'beginner',
  [LEVEL_VALUES.MID_LEVEL]: 'mid',
  [LEVEL_VALUES.EXPERT_LEVEL]: 'expert',
}

export const TYPE_VALUES = {
  DRIVE_BY: 0,
  ATTACHMENT: 1,
  CALL_FOR_ACTIONS: 2,
  SMISHING: 3,
  ALL_TYPES: 4,
  SMS_NAG_ATTACK: 5,
}
export const TYPE_LABELS = {
  [TYPE_VALUES.DRIVE_BY]: 'Drive-By',
  [TYPE_VALUES.ATTACHMENT]: 'Attachment',
  [TYPE_VALUES.CALL_FOR_ACTIONS]: 'Call To Action',
  [TYPE_VALUES.SMISHING]: 'Smishing',
  [TYPE_VALUES.ALL_TYPES]: 'All Types',
  [TYPE_VALUES.SMS_NAG_ATTACK]: 'SMS Nag-Attack',
}
export const EMAIL_SCENARIOS_TYPE_OPTIONS = [
  { label: TYPE_LABELS[TYPE_VALUES.ALL_TYPES], value: TYPE_VALUES.ALL_TYPES },
  { label: TYPE_LABELS[TYPE_VALUES.DRIVE_BY], value: TYPE_VALUES.DRIVE_BY },
  { label: TYPE_LABELS[TYPE_VALUES.ATTACHMENT], value: TYPE_VALUES.ATTACHMENT },
  {
    label: TYPE_LABELS[TYPE_VALUES.CALL_FOR_ACTIONS],
    value: TYPE_VALUES.CALL_FOR_ACTIONS,
  },
]
export const SMS_SCENARIOS_TYPE_OPTIONS = [
  { label: TYPE_LABELS[TYPE_VALUES.ALL_TYPES], value: TYPE_VALUES.ALL_TYPES },
  { label: TYPE_LABELS[TYPE_VALUES.SMISHING], value: TYPE_VALUES.SMISHING },
  {
    label: TYPE_LABELS[TYPE_VALUES.SMS_NAG_ATTACK],
    value: TYPE_VALUES.SMS_NAG_ATTACK,
  },
]
export const MAP_SCENARIOS_TYPE_OPTIONS_BY_DELIVERY = {
  [DELIVERY.EMAIL]: EMAIL_SCENARIOS_TYPE_OPTIONS,
  [DELIVERY.SMS]: SMS_SCENARIOS_TYPE_OPTIONS,
}

export const CREATED_BY_VALUES = {
  IRONSCALES: 1,
  SERVICE_PROVIDER: 2,
  COMMUNITY: 3,
}

export const CREATED_BY_LABELS = {
  [CREATED_BY_VALUES.IRONSCALES]: 'System',
  [CREATED_BY_VALUES.SERVICE_PROVIDER]: 'MSP',
  [CREATED_BY_VALUES.COMMUNITY]: 'Community',
}

export const CREATED_BY_OPTIONS = [
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.IRONSCALES],
    value: CREATED_BY_VALUES.IRONSCALES,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.COMMUNITY],
    value: CREATED_BY_VALUES.COMMUNITY,
  },
]

export const AUTO_SELECT_VALUES = {
  LEVELED: 0,
  RANDOMIZED: 1,
}
